
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import MAIDoctorSerializer from '../types/MAIDoctorSerializer_apps_MAI'


const HOST = `${config.API_HOST}`
/* ['generics.ListAPIView', 'SetLanguageContextMixin'] */
/* params: 'patient' */
/* data:  */
const MasterEDCList : 
{
  list:     ({params, apiToken, extra}:
            { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/BIL/master-edc/`,
      { params: params ? { ...params } : {},
        ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default MasterEDCList

